import VCNotifications from './VCNotifications';

export default VCNotifications;
